import { render, staticRenderFns } from "./ComparisonItem.vue?vue&type=template&id=6b12c9d5"
import script from "./ComparisonItem.vue?vue&type=script&lang=js"
export * from "./ComparisonItem.vue?vue&type=script&lang=js"
import style0 from "./ComparisonItem.vue?vue&type=style&index=0&id=6b12c9d5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b12c9d5')) {
      api.createRecord('6b12c9d5', component.options)
    } else {
      api.reload('6b12c9d5', component.options)
    }
    module.hot.accept("./ComparisonItem.vue?vue&type=template&id=6b12c9d5", function () {
      api.rerender('6b12c9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/modelcomparison/assets/frontend/components/ComparisonItem.vue"
export default component.exports